import { useState, useEffect, useRef, useContext } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { MdOutlineLocalPrintshop, MdOutlineFactCheck, MdOutlineMoreTime, MdOutlineTextIncrease, MdOutlineTextDecrease, MdOutlineFileDownload, MdCheckBoxOutlineBlank, MdClose } from "react-icons/md";

import './css/Audio.css'

import { Img } from "../../../components/Elements";
import { AppContext } from "../../../Context";
import Header from "../../task/Header";
import Fetch, { Loader, GET, permissions } from "../../../inc/Fetch";
import Permission from '../../Permission'
import { Config } from '../../../inc/Config';
import { AiOutlineFullscreen } from 'react-icons/ai';


export default function Task({action}) {

    const { t } = useTranslation();

    const ref = useRef();
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    
    const [audio, setaudio] = useState("");
    const [imgSelect, setimgSelect] = useState(0);
    const [imgClick, setimgClick] = useState(false);
    const [fontsize, setfontsize] = useState(12);
    const [fullscreen, setfullscreen] = useState(false);


    async function loadData() {
        let r = await GET(`audio/view_one?_id=${params?.id}`); 
        return r;
    }

    function selectAudio(mp3) {
        setaudio(mp3);
        ref.current?.pause();
        ref.current?.setAttribute('src', Config?.imgUrl + mp3);
        ref.current?.load();
        setTimeout(() => {
            ref.current?.play();
        }, 500);
    }

    function fontSizeCg(st) {

        if (st) {
            setfontsize(p => p <= 12 ? 12 :  p - 2);
        } else {
            setfontsize(p => p >= 18 ? 18 :  p + 2);
        }
        
    }

    const { data, error, isLoading } = useQuery(`music_${params?.id}`, loadData); 
    
    useEffect(() => {
        setimgSelect(data?.music?.img?.length ? data?.music?.img[0] : "");
    }, [data?.music?.img]);

    useEffect(() => {
        if (data?.music?.music && typeof Object.keys(data?.music?.music)[0] != 'undefined') {
            let k = Object.keys(data?.music?.music)[0];
            if (data?.music?.music[k]) {
                setaudio(data?.music?.music[k][0]);
            }
        }

        
    }, [data?.music?.music]);

    function fullScreen() {

        setfullscreen(p => !p);
        
    }

    
    useEffect(() => {
        loadData();
    }, []);

    
    if (isLoading){
        return <Loader />
    }
    
    if (!userinfo?._id ) {
        return <Permission />
    } else {

        let perms = permissions(userinfo, params?.id, data?.music?.cat?.val,  "music");
        if (!perms) {
            return <Permission />

        }
    }

    
    
    
    return (
        <>
            <div className='taskNewBody' style={{padding:0}}>
                
                <Header title={data?.music?.title}/>

                <div className='rightTaskMenu'>
                                    
 
                    <a tabIndex="0"  onClick={fullScreen} >
                        <AiOutlineFullscreen />
                        <span>{t("fullscreen")}</span>
                    </a>
                    <a tabIndex="0" onKeyDown={(e) => { if (e.key === 'Enter') {  fontSizeCg(); } }} onClick={() => fontSizeCg()} >
                        <MdOutlineTextIncrease />
                        <span>{t("task_start_opt_7")}</span>
                    </a>
                    <a tabIndex="0" onKeyDown={(e) => { if (e.key === 'Enter') {  fontSizeCg(true); } }} onClick={() => fontSizeCg(true)}>
                        <MdOutlineTextDecrease />
                        <span>{t("task_start_opt_8")}</span>
                    </a>

                    
                </div>

                <div></div>
                <div className={`taskBody audioContainer f-${fontsize} ${fullscreen && "fullscreen"}`} style={{justifyContent:"center"}}>
                    <div className={`mainWidth taskMainBox`}>
                        <div className={`taskBox right`}>

                            <a onClick={() => setfullscreen(false)} className='closeAfter'>
                                <MdClose />
                            </a>

                            <div className='mainTitleBox audioTitleBox'>
                                <h2>{data?.music?.title}</h2>
                                <nav>
                                    <Link to={`/site/${data?.music?.cat?.name}/audio`} className='tagInfo'>{data?.music?.cat?.name}</Link>
                                    {data?.music?.classes?.map((v, k) => {
                                        return (
                                            <a key={k} className='tagInfo'>{t("class")} {global?.Classes[v]}</a>
                                        )
                                    })}
                                </nav>
                            </div>


                            <div className='fullText' dangerouslySetInnerHTML={{__html:data?.music?.full }} />
                        </div>
                        <div className={`taskBox left`}>

                            

                            {data?.music?.music ? <div className='audioPlayerBox'>
                                <nav>
                                    {Object.keys(data?.music?.music)?.map((v, k) => {

                                        const mp3 = data?.music?.music[v];
                                        if (mp3?.length) {
                                            return (
                                                <a tabIndex="0" key={k} onKeyDown={(e) => { if (e.key === 'Enter') {  selectAudio(mp3) } }} onClick={() => selectAudio(mp3)} className={audio == mp3 ? 'ck' : "null"}>
                                                    {v == '0' && "Transpose 0"}
                                                    {v == '1' && "Transpose -1"}
                                                    {v == '2' && "Transpose +1"}
                                                    {v == '3' && t("audio_dom")}
                                                    {v == '4' && t("audio_sing")}
                                                </a>
                                            );
                                        }
                                    
                                    })}
                                   
                                </nav>
                                {audio && <audio controlsList="nodownload" ref={ref} controls>
                                    <source src={Config?.imgUrl + audio} type="audio/mpeg" />
                                </audio>}
                                
                            </div>: false}

                            <div className={`noteImageBox ${imgClick ? 'full' : 'reg'}`} >
                                {imgClick && <a onClick={() => setimgClick(false)} className='closeImgFull'><MdClose /></a>}
                                {imgSelect && <a onClick={() => setimgClick(p => !p)}><Img className="mainNoteImg" src={imgSelect} /></a>}
                                
                                <div className='noteThumb'>
                                    {data?.music?.img?.map((v, k) => {
                                        return (
                                            <a onClick={() => setimgSelect(v)}><Img className={imgSelect == v ? "ck" : "null"} src={`img/60x60/${v}`} /></a>
                                        );
                                    })}
                                </div>


                            </div>

                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
